export const GROUPS_ENDPOINT = '/groups/'

export const SET_GROUPS = 'SET_GROUPS'
export const ADD_GROUP = 'ADD_GROUP'
export const UPDATE_GROUP = 'UPDATE_GROUP'
